import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { PATH } from 'src/features/navigation/utils/constants';
import { PayStationOperation } from 'src/features/payment/utils/types';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellPayStationOperationActions({ row }: CellContext<PayStationOperation, unknown>) {
    return (
        <div className="flex gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/${PATH.PAYMENTS}/operation/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
